module.exports = __webpack_public_path__ + "img/selfc9.03f64b13.svg";